module.exports = __webpack_public_path__ + "img/Billet_2.5962d82.svg";